import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({
  colors: {
    primary: '#2B2B2B',
    secondary: '#010101',
    black: '#000',
    white: '#fff',
    yellow: '#F8CF4A',
    brand: {
      10: '#FFFFFF',
      50: '#DC2C48',
      60: '#C94754',
      70: '#BA494C',
      80: '#BBBBBB',
      100: '#EEEEEE',
      110: '#DBDBDB',
      120: '#F1F1F1',
    },
  },
});
